/**
 * useMediaQuery Hook
 * Detect screen sizes and device types
 */

import { useState, useEffect } from 'react';

export const BREAKPOINTS = {
  mobile: 768,    // 0-767px = mobile
  tablet: 1024,   // 768-1023px = tablet
  desktop: 1280,  // 1024+ = desktop
};

export function useMediaQuery() {
  const [screenSize, setScreenSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    
    // Call once to set initial size
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenSize.width < BREAKPOINTS.mobile;
  const isTablet = screenSize.width >= BREAKPOINTS.mobile && screenSize.width < BREAKPOINTS.tablet;
  const isDesktop = screenSize.width >= BREAKPOINTS.tablet;

  return {
    isMobile,
    isTablet,
    isDesktop,
    width: screenSize.width,
    height: screenSize.height,
  };
}

export default useMediaQuery;
